'use client';

import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import logTrailDetailsActionTapped from '@alltrails/amplitude/events/logTrailDetailsActionTapped';
import type { TrailId } from '@alltrails/types/TrailId';
import { ratingToFormattedRating } from '@alltrails/shared/utils/dataConversions';
import { scrollToSectionId } from '@alltrails/core';
import Link from '@alltrails/denali/components/Link';
import type { Size } from '@alltrails/denali/types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from './Rating.module.scss';
import { REVIEWS_SECTION_ID } from '@/utils/constants';

type RatingProps = {
  rating: number;
  reviewCount: number;
  size?: Size<'sm' | 'md'>;
  trailId: TrailId;
};

const Rating = ({ rating, reviewCount, size = 'md', trailId }: RatingProps) => {
  const languageRegionCode = useLanguageRegionCode();
  const localizedRating = ratingToFormattedRating(rating, languageRegionCode);

  const onRatingClick = () => {
    logTrailDetailsActionTapped({
      trail_id: String(trailId),
      trail_page_action: 'show all reviews',
      trail_page_location: 'header bar'
    });
    scrollToSectionId(REVIEWS_SECTION_ID);
  };

  return (
    <div className={classNames(styles.ratingAndReviews, styles.ratingLink, styles[size])}>
      <span data-testid="trail-rating">{localizedRating}</span>
      <div>
        (
        <Link className={classNames(styles.ratingLink, styles[size])} onClick={onRatingClick}>
          <FormattedMessage defaultMessage="{reviewCount, plural, one {# review} other {# reviews}}" values={{ reviewCount }} />
        </Link>
        )
      </div>
    </div>
  );
};

export default Rating;
